import "./Style.css";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { ClipLoader } from "react-spinners";

const LoginModal = ({
  showLoginModal,
  handleClose,
  handleLogin,
  setEmailActive,
  emailActive,
  inputData,
  setinputData,
  handleSendOtp,
  showOtpInput,
  handleSubmitOtp,
  showLoading,
  setReferalCode,
  referalCode,
}) => {
  return (
    <div className={"Login-modal-main-container"}>
      <Modal
        backdrop="static"
        className={"Login-modal-outter-container"}
        show={showLoginModal}
        onHide={handleClose}
        animation={false}
      >
        <Modal.Header className="Login-modal-header-section" closeButton>
          <Modal.Title className={"LoginModal-heading"}>Login</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mobile-email-outer-div mb-2">
            <button
              className={emailActive ? "email-butt-for " : "email-butt-active"}
              onClick={() => {
                setEmailActive(true);
                setinputData({ ...inputData, Mobile: "" });
              }}
            >
              Email
            </button>
            <button
              className={emailActive ? "email-butt-active" : "email-butt-for"}
              onClick={() => {
                setEmailActive(false);
                setinputData({ ...inputData, Email: "" });
              }}
            >
              By Mobile Number
            </button>
          </div>
         
          <div className="lf-input-box main-div-input">
            <div className="used-icon-password-visible">
              {showOtpInput ? (
                <input
                  className="w-100"
                  placeholder="Enter Otp"
                  type="text"
                  name="email"
                  value={inputData?.Otp}
                  onChange={(e) =>
                    setinputData({ ...inputData, Otp: e.target.value })
                  }
                />
              ) : emailActive ? (
                <input
                  className="w-100"
                  placeholder="Enter Email"
                  type="text"
                  name="email"
                  value={inputData?.Email}
                  onChange={(e) =>
                    setinputData({
                      ...inputData,
                      Email: e.target.value,
                      Mobile: "",
                    })
                  }
                />
              ) : (
                <input
                  className="w-100"
                  placeholder="Enter Mobile Number"
                  type="text"
                  maxlength="10"
                  value={inputData?.Mobile}
                  onChange={(e) =>
                    setinputData({
                      ...inputData,
                      Mobile: e.target.value,
                      Email: "",
                    })
                  }
                ></input>
              )}
               {referalCode && (
            <input
              className="w-100"
              style={{marginTop:"10px"}}
              placeholder="Enter Referal Code"
              type="text"
              value={inputData?.Otp}
              onChange={(e) =>
                setinputData({ ...inputData, Otp: e.target.value })
              }
            />
          )}
            </div>
          </div>
          <div className="lf-btn border-0 py-3">
            <p className="validate-error text-center mb-2"></p>
            {showOtpInput ? (
              showLoading == "submitotp" ? (
                <button>
                  <ClipLoader className="main_loader_home" loading size={15} />
                </button>
              ) : (
                <button onClick={() => handleSubmitOtp()}>Submit OTP</button>
              )
            ) : showLoading == "otpsent" ? (
              <button>
                <ClipLoader className="main_loader_home" loading size={15} />
              </button>
            ) : (
              <button onClick={handleSendOtp}>Send OTP</button>
            )}
          </div>

          {/* <img
            className={"Modal-Image-forlogin"}
            src="/Images/google-image-for-login.jpg"
            alt="Shop Saverz Logo"
            // width={150}
            // height={50}
            layout="intrinsic"
          /> */}
        </Modal.Body>
        <h4 className="text-center">OR</h4>
        <Modal.Footer className="Login-modal-footer">
          <Button onClick={handleLogin}>
            <img
              className="Login-modal-icon"
              src="/Images/Login-modal-Icon.png"
              alt="Shop Saverz Logo"
              layout="intrinsic"
            />
            Sign in with Google
          </Button>
        </Modal.Footer>
        {referalCode ?
        <p class="mb-0 mt-4 text-center" onClick={() => setReferalCode(false)}>
        <a class="link-refer-login">Cancel</a>
      </p>
      :
      <p class="mb-0 mt-4 text-center" onClick={() => setReferalCode(true)}>
          <a class="link-refer-login">Have Referral Code?</a>
        </p>
      }
        
      </Modal>
    </div>
  );
};

export default LoginModal;
